<template>
  <div class="scroll-section scroll-section-passion">
    <div class="passion-texts">
      <header class="passion-header animate">
        <h1>
          <strong>
            <span>P </span>
            <dot-matrix :dotcolor="'45, 51, 53'" :cols="7" :rows="6" :pattern="letter.map" :dotsize="5"
                        :dotgap="3"></dot-matrix>
            <span>ssion</span>
          </strong>
        </h1>
        <h1>{{ $t('passion.header') }}</h1>
      </header>
      <article class="passion-description animate">
        <p><strong>{{ $t('passion.sub_header') }}</strong></p>
        <p>{{ $t('passion.paragraph_1') }}</p>
        <p>{{ $t('passion.paragraph_2') }}</p>
        <p class="signature">Mr. Bot</p>
        <p class="description">{{ $t('passion.bot_desc') }}</p>
      </article>
    </div>
  </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex'
    import dotMatrix from '.././dotMatrix.vue'

    export default {
        name: 'Passion',
        components: {
            dotMatrix
        },
        data() {
            return {
                nav_title: 'passion',
                exclude_from_nav: true,
                loopedAnimationsPaused: true,
                animationsDone: false,
                animationsInit: false,
                // component specific
                letter: {
                    map: [
                        0, 0, 0, 1, 0, 0, 0,
                        0, 0, 1, 1, 1, 0, 0,
                        0, 1, 1, 1, 1, 1, 0,
                        1, 1, 1, 1, 1, 1, 1,
                        1, 1, 1, 0, 1, 1, 1,
                        0, 1, 0, 0, 0, 1, 0
                    ]
                }
            }
        },
        mounted() {
            this.hideElements();
            this.addDotMatrixTimeline();
        },
        watch: {
            active_section_name(val) {
                if (val === this.$options._componentTag) {
                    if (!this.is_animating_scroll) {
                        this.runSectionAnimations()
                    }
                }
            },
            scroll_pos(val) {
                if (this.scroll_pos > (this.$el.offsetTop - 300) && this.scroll_pos < ((this.elHeight - 300) + this.$el.offsetTop)) {
                  if (!this.is_animating_scroll) {
                    this.runSectionAnimations()
                    this.setActiveSection(this.$options._componentTag)
                  }
                }
            }
        },
        computed: {
            ...mapGetters({
                active_section_name: 'getActiveSectionName',
                scroll_pos: 'getScrollPos',
                is_animating_scroll: 'getAnimatingScrollState'
            }),
            elHeight() {
                return Math.ceil(this.$el.getBoundingClientRect().height)
            }
        },
        methods: {
            ...mapActions([
                'setActiveSection'
            ]),
            hideElements() {
                let elements = this.$el.querySelectorAll('.animate');
                if (window.ieLegacy()) {
                    return;
                }
                TweenMax.set(elements, {
                    autoAlpha: 0
                });
            },
            addDotMatrixTimeline() {
                let _this = this
                let animationProps = {
                    frameIndex: 0,
                    frames: [
                        [
                            0, 0, 0, 1, 0, 0, 0,
                            0, 0, 1, 1, 1, 0, 0,
                            0, 1, 1, 1, 1, 1, 0,
                            1, 1, 1, 1, 1, 1, 1,
                            1, 1, 1, 0, 1, 1, 1,
                            0, 1, 0, 0, 0, 1, 0
                        ], [
                            0, 0, 1, 1, 1, 0, 0,
                            0, 1, 1, 1, 1, 1, 0,
                            1, 1, 1, 1, 1, 1, 1,
                            1, 1, 1, 0, 1, 1, 1,
                            0, 1, 0, 0, 0, 1, 0,
                            0, 0, 0, 0, 0, 0, 0
                        ], [
                            0, 1, 1, 1, 1, 1, 0,
                            1, 1, 1, 1, 1, 1, 1,
                            1, 1, 1, 0, 1, 1, 1,
                            0, 1, 0, 0, 0, 1, 0,
                            0, 0, 0, 0, 0, 0, 0,
                            0, 0, 0, 0, 0, 0, 0
                        ], [
                            1, 1, 1, 1, 1, 1, 1,
                            1, 1, 1, 0, 1, 1, 1,
                            0, 1, 0, 0, 0, 1, 0,
                            0, 0, 0, 0, 0, 0, 0,
                            0, 0, 0, 0, 0, 0, 0,
                            0, 0, 0, 0, 0, 0, 0
                        ], [
                            1, 1, 1, 0, 1, 1, 1,
                            0, 1, 0, 0, 0, 1, 0,
                            0, 0, 0, 0, 0, 0, 0,
                            0, 0, 0, 0, 0, 0, 0,
                            0, 0, 0, 0, 0, 0, 0,
                            0, 0, 0, 0, 0, 0, 0
                        ], [
                            0, 1, 0, 0, 0, 1, 0,
                            0, 0, 0, 0, 0, 0, 0,
                            0, 0, 0, 0, 0, 0, 0,
                            0, 0, 0, 0, 0, 0, 0,
                            0, 0, 0, 0, 0, 0, 0,
                            0, 1, 0, 0, 0, 1, 0
                        ], [
                            0, 0, 0, 0, 0, 0, 0,
                            0, 0, 0, 0, 0, 0, 0,
                            0, 0, 0, 0, 0, 0, 0,
                            0, 0, 0, 0, 0, 0, 0,
                            0, 1, 0, 0, 0, 1, 0,
                            1, 1, 1, 0, 1, 1, 1
                        ], [
                            0, 0, 0, 0, 0, 0, 0,
                            0, 0, 0, 0, 0, 0, 0,
                            0, 0, 0, 0, 0, 0, 0,
                            0, 1, 0, 0, 0, 1, 0,
                            1, 1, 1, 0, 1, 1, 1,
                            1, 1, 1, 1, 1, 1, 1
                        ], [
                            0, 0, 0, 0, 0, 0, 0,
                            0, 0, 0, 0, 0, 0, 0,
                            0, 1, 0, 0, 0, 1, 0,
                            1, 1, 1, 0, 1, 1, 1,
                            1, 1, 1, 1, 1, 1, 1,
                            0, 1, 1, 1, 1, 1, 0
                        ], [
                            0, 0, 0, 0, 0, 0, 0,
                            0, 1, 0, 0, 0, 1, 0,
                            1, 1, 1, 0, 1, 1, 1,
                            1, 1, 1, 1, 1, 1, 1,
                            0, 1, 1, 1, 1, 1, 0,
                            0, 0, 1, 1, 1, 0, 0
                        ], [
                            0, 1, 0, 0, 0, 1, 0,
                            1, 1, 1, 0, 1, 1, 1,
                            1, 1, 1, 1, 1, 1, 1,
                            0, 1, 1, 1, 1, 1, 0,
                            0, 0, 1, 1, 1, 0, 0,
                            0, 0, 0, 1, 0, 0, 0
                        ]
                    ]
                }
                let numOfFrames = animationProps.frames.length
                this.dotMatrixTimeline = new TimelineMax({repeat: -1, repeatDelay: 2, yoyo: true})
                this.dotMatrixTimeline.to(animationProps, 1.7, {
                    frameIndex: numOfFrames - 1,
                    ease: Power0.easeNone,
                    onUpdate() {
                        let frameArrIndex = Math.floor(animationProps.frameIndex)
                        _this.letter.map = animationProps.frames[frameArrIndex]
                    }
                })
                this.dotMatrixTimeline.pause()
            },
            runSectionAnimations() {
                if (this.animationsDone || this.animationsInit) return
                let _this = this

                let mainTimeline = new TimelineMax({
                    repeat: 0,
                    onComplete() {
                        _this.dotMatrixTimeline.play()
                    }
                })

                let header = this.$el.querySelector('.passion-header')
                let description = this.$el.querySelector('.passion-description')

                mainTimeline.fromTo(header, 1.2, {
                    y: 60
                }, {
                    y: 0,
                    ease: Power1.easeOut
                }).to(header, 0.3, {
                    autoAlpha: 1,
                    ease: Power2.easeOut
                }, 0).fromTo(description, 1.1, {
                    y: 60
                }, {
                    y: 0,
                    ease: Power1.easeOut
                }, 0.2).to(description, 0.4, {
                    autoAlpha: 1,
                    ease: Power2.easeOut
                }, 0.2)

                this.animationsInit = true
            }
        }
    }
</script>

<style lang="scss" scoped>
  @import '../.././assets/variables';

  .scroll-section {
    padding-bottom: 70px;
    background-color: $city_bg;
    display: flex;
    justify-content: center;
    position: relative;
    @media screen and (max-width: 768px) {
      z-index: 1;
    }
    @media screen and (max-width: 480px) {
      padding-bottom: 30px;
    }
  }
</style>

<style lang="scss">

  .scroll-section-passion {

  }

  .passion-texts {
    width: 100%;
    max-width: 730px;
    text-align: center;
    @media screen and (max-width: 768px) {
      padding: 0 1.5rem;
    }

    @media screen and (max-width: 768px) {
      padding-top: 0px;
    }

    h1 {
      font-size: 3.5rem;
      line-height: 1.2;
      text-transform: uppercase;

      strong {
        font-family: "Gotham Rounded SSm A", "Gotham Rounded SSm B";

        > .tiny-dot-matrix {
          @media screen and (max-width: 480px) {
            transform: scale(0.5);
            margin-bottom: -.5rem;
            margin-left: -1.2rem;
            margin-right: -1rem;
          }
        }
      }

      + h1 {
        margin-bottom: 2.5rem;
        @media screen and (max-width: 480px) {
          margin-bottom: 1.5rem;
        }
      }

      @media screen and (max-width: 480px) {
        font-size: 1.9rem;
      }
    }

    p {
      font-size: 1.125rem;
      line-height: 1.9rem;
      margin-bottom: 1.8rem;

      &:first-of-type {
        margin-bottom: 0;
      }
    }

    .signature {
      font-size: 3.8rem;
      font-family: 'angelique_roseregular';
      line-height: 1;
      color: #122360;
      margin-bottom: 0.2rem;
      padding-top: .3rem;
      @media screen and (max-width: 480px) {
        font-size: 2.8rem;
      }
    }

    .description {
      text-transform: uppercase;
      color: #4f7da1;
      font-weight: 700;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/sections/Passion.vue